import { render, staticRenderFns } from "./imported.vue?vue&type=template&id=0a42b79e&"
import script from "./imported.vue?vue&type=script&lang=js&"
export * from "./imported.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports